import { Preferences } from '@capacitor/preferences'
import {
  OFFLINE_QUEUE_SNAPSHOT_KEY,
  parseOfflineQueueSnapshot,
  serializeOfflineQueueSnapshot,
  type OfflineQueueSnapshot,
} from './offlineQueue'

export async function readOfflineQueueSnapshot (): Promise<OfflineQueueSnapshot | null> {
  try {
    const { value } = await Preferences.get({ key: OFFLINE_QUEUE_SNAPSHOT_KEY })
    return parseOfflineQueueSnapshot(value)
  } catch {
    return null
  }
}

export async function writeOfflineQueueSnapshot (
  snapshot: OfflineQueueSnapshot,
): Promise<void> {
  try {
    await Preferences.set({
      key: OFFLINE_QUEUE_SNAPSHOT_KEY,
      value: serializeOfflineQueueSnapshot(snapshot),
    })
  } catch {
    /* Preferences is native-only; ignore on web and in unit tests. */
  }
}
